import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Input, Button, Modal } from "antd";
import {
  confirmVerification,
  verificationRequestEmail,
  verificationRequestPhone,
} from "../../api";
import { commonUtil } from "../../utils";

interface Props {
  type: "email" | "phone";
  verificationId: number;
  value: string;
  feature: string;
  onClose?: (data?: any) => void;
  onResend: (verificationId: number) => void;
  onConfirmSuccess?: (data?: any) => void;
  onConfirmFail?: (data?: any) => void;
}

const EnterOtp: React.FC<Props> = (props: Props) => {
  const { t } = useTranslation(["common", "notification"]);
  const [isDisabled, setIsDisabled] = useState<boolean>(true);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [listDigit, setListDigit] = useState<string[]>([
    "",
    "",
    "",
    "",
    "",
    "",
  ]);
  const [timeLeft, setTimeLeft] = useState<number>(60);
  const [failTimes, setFailTimes] = useState<number>(0);
  const digitRef = useRef<any>([]);
  useEffect(() => {
    setIsDisabled(
      listDigit.some((digit: string) => digit === "" || isNaN(Number(digit))) ||
        failTimes >= 5
    );
  }, [listDigit, failTimes]);
  useEffect(() => {
    const timer = setTimeout(() => {
      setTimeLeft(timeLeft - 1);
    }, 1000);
    return () => clearTimeout(timer);
  });

  const handleConfirmOtp = async (otp: string) => {
    setIsLoading(true);
    const resConfirmOtp = await confirmVerification({
      code: otp,
      feature: props.feature,
      verificationId: props.verificationId,
    });
    if (resConfirmOtp.status === "success") {
      if (props.onConfirmSuccess) {
        props.onConfirmSuccess();
      }
    } else {
      commonUtil.showMessage("error", resConfirmOtp.message);
      setFailTimes(Math.min(failTimes + 1, 5));
      if (props.onConfirmFail) {
        props.onConfirmFail();
      }
    }
    setIsLoading(false);
  };

  const handleChange = (index: number, value: string) => {
    if (!value) {
      const _newList = [...listDigit];
      _newList[index] = "";
      setListDigit(_newList);
      if (index > 0) {
        digitRef.current[index - 1].focus(); // focus into prev input
        digitRef.current[index - 1].select(); // focus into next input
      }
    } else if ("0123456789".includes(value.slice(-1))) {
      const _newList = [...listDigit];
      _newList[index] = value.slice(-1);
      setListDigit(_newList);
      if (index < 5) {
        digitRef.current[index + 1].focus(); // focus into next input
        digitRef.current[index + 1].select(); // focus into next input
      }
    }
  };

  const handleBackspace = (index: number) => {
    const _newList = [...listDigit];
    _newList[index] = "";
    setListDigit(_newList);
    if (index > 0) {
      digitRef.current[index - 1].focus(); // focus into prev input
      digitRef.current[index - 1].select(); // focus into next input
    }
  };

  const handlePaste = (index: number, value: string) => {
    value.replace(/ /g, ""); // remove space
    if (value.length > 1) {
      setListDigit(
        Array.from(value.substr(0, 6)).map((digit) => {
          return isNaN(Number(digit)) ? "" : digit;
        })
      );
    } else {
      handleChange(index, value);
    }
  };

  // const onResendClick = async () => {
  //   const res =
  //     props.type === 'email'
  //       ? await verificationRequestEmail({ feature: props.feature, email: props.value })
  //       : await verificationRequestPhone({
  //         feature: props.feature,
  //         phone: commonUtil.convertPhone(props.value),
  //       })
  //   if (res.status === 'error') {
  //     commonUtil.showMessage('error', res.message)
  //   } else {
  //     setListDigit(['', '', '', '', '', ''])
  //     setTimeLeft(60)
  //     setFailTimes(0)
  //     props.onResend(res.data.verificationId)
  //   }
  // }

  return (
    <Modal
      visible={true}
      footer={null}
      maskClosable={false}
      title={t("common:Nhập mã OTP")}
      onCancel={props.onClose}
    >
      <p className="mt-32 mb-16">
        {props.type === "email"
          ? t("common:Mã OTP vừa được gửi tới email")
          : null}
        {props.type === "phone"
          ? t("common:Mã OTP vừa được gửi tới số điện thoại")
          : null}{" "}
        <strong>{props.value}</strong>
      </p>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "12px",
        }}
      >
        {[0, 1, 2, 3, 4, 5].map((item) => {
          return (
            <div key={`digit-${item}`} style={{ padding: "5px" }}>
              <Input
                // type="number"
                style={{
                  padding: "0 5px",
                  textAlign: "center",
                  width: "40px",
                  height: "40px",
                }}
                ref={(ref) => {
                  digitRef.current[item] = ref;
                }}
                maxLength={1}
                value={listDigit[item]}
                // onChange={(event) => handleChange(item, event.target.value)}
                onPaste={(event: any) =>
                  handlePaste(item, event.clipboardData.getData("text"))
                }
                onPressEnter={() => {
                  if (!isDisabled) {
                    handleConfirmOtp(listDigit.join(""));
                  }
                }}
                onKeyDown={(e) => {
                  if (e.key === "Backspace") {
                    handleBackspace(item);
                  } else if ("0123456789".includes(e.key)) {
                    handleChange(item, e.key);
                  }
                }}
              />
            </div>
          );
        })}
      </div>
      <Button
        type="primary"
        size="large"
        style={{
          textTransform: "uppercase",
          fontWeight: 600,
          marginBottom: "12px",
        }}
        disabled={isDisabled}
        className={`${isDisabled && "pointer-events-none"}`}
        onClick={() => handleConfirmOtp(listDigit.join(""))}
        loading={isLoading}
        block={true}
      >
        <span>{t("common:Xác thực")}</span>
      </Button>
    </Modal>
  );
};

export default EnterOtp;
